import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import Search from '../search';

class Autocomplete extends PureComponent {

  static propTypes = {
    fieldName: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(PropTypes.object),
    maxItems: PropTypes.number,
    minChars: PropTypes.number,
    onSelect: PropTypes.func,
    notFoundMessage: PropTypes.string,
    placeholder: PropTypes.string
  }

  static defaultProps = {
    data: [],
    maxItems: 5,
    minChars: 0,
    onSelect: () => {},
    notFoundMessage: 'Keine Einträge gefunden',
    placeholder: ''
  }

  constructor() {
    super();

    this.state = {
      results: []
    }
  }

  onInput = (inputValue = '') => {
    if (inputValue.length < this.props.minChars) {
      return this.setState({ results: [] });
    }

    const results = this.props.data.filter(d => (
      d[this.props.fieldName] && d[this.props.fieldName]
        .toString()
        .toUpperCase()
        .indexOf(inputValue.toUpperCase()) === 0
    ));

    this.setState({ results });
  }

  onSelect = (resultItem) => {
    this.props.onSelect(resultItem);
    this.setState({ results: [] });
  }

  reset = () => {
    this.setState({ results: [] });
    this.search.reset();
    this.props.reset()
  }

  onBlur = () => {
    setTimeout(() => this.setState({ results: [] }), 200)

  }

  render() {
    return (
      <Search
        maxItems={this.props.maxItems}
        results={this.state.results}
        onInput={this.onInput}
        onFocus={() => this.onInput()}
        onBlur={() => this.onBlur()}
        onSelect={this.onSelect}
        labelKey={this.props.fieldName}
        placeholder={this.props.placeholder}
        notFoundMessage={this.props.notFoundMessage}
        ref={ref => { this.search = ref; }}
        reset={this.reset}
        selectedData={this.props.selectedData}
      />
    );
  }
}

export default Autocomplete;